import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/snells-law-calculator',
  component: () => import('../../routes/SnellsLawCalculator.svelte'),
  card: {
    id: 'snells-law-calculator',
    title: "Snell's Law Calculator",
    description:
      "Calculate refraction angles using Snell's Law (n₁·sin θ₁ = n₂·sin θ₂). Includes critical-angle check for total internal reflection, Fresnel reflectance/transmittance, 18 medium presets (air, water, glass, diamond), and 8 example scenarios.",
    icon: 'auto_awesome',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/snells-law-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: "Snell's Law Calculator – Refraction, Critical Angle & Fresnel Reflectance",
    description:
      "Free Snell's law calculator: solve for the refraction angle, the second medium's refractive index, or the critical angle for total internal reflection. Includes Fresnel reflectance for s- and p-polarized light, 18 material presets, and worked examples (air→water, water→air TIR, glass→diamond).",
  },
};

export default meta;
